__turbopack_context__.v({
  "component": "style-module-scss-module__dQ726G__component",
  "container": "style-module-scss-module__dQ726G__container",
});
